var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.96106 0.5625H16.0382C16.416 0.5625 16.7437 0.700507 17.0216 0.978516C17.2996 1.25638 17.4376 1.58412 17.4376 1.96191V12.7051C17.4376 13.0815 17.2996 13.4077 17.0216 13.6846C16.7437 13.9616 16.416 14.0996 16.0382 14.0996H3.86536L3.85754 14.1064L1.73645 16.2285C1.62717 16.3377 1.5109 16.4039 1.38782 16.4287C1.26452 16.4534 1.13163 16.4369 0.98938 16.3779C0.847051 16.319 0.741666 16.2378 0.671997 16.1348C0.602396 16.0318 0.567558 15.9052 0.567505 15.7539V1.96191C0.567505 1.58407 0.705499 1.25638 0.982544 0.978516C1.2593 0.700757 1.58494 0.562605 1.96106 0.5625ZM1.93665 14.2666L1.97961 14.2197L3.34485 12.7305H16.0636V1.93652H1.93665V14.2666Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.a21fb350777e6aadc8a9fcf29306a63b.svg";
export { ForwardRef as ReactComponent };